// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3pmRS","buttons":"PendingPaymentAlert_buttons__4UJ7T"};